<div class="hero">
  <div class="hero-card">
    <app-grade-unit-card
      [gradeUnitListItem]="card"
      [startDate]="startDate"
      [showImageData]="showImageData"
      [isGrades]="isGrades"
    ></app-grade-unit-card>
  </div>
  <div class="hero-body">
    <div class="hero-body__heading">
      <span>Unit {{ card?.unitNumber }}</span>
      <h1>{{ card?.unitTitle }}</h1>
    </div>
    <div class="hero-body__content">
      <article>{{ card?.unitDescription }}</article>
    </div>
  </div>
</div>
